import React, { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import _ from 'lodash';
import cx from 'classnames';
import Truncate from 'react-truncate';
import { Frame } from "scenejs";
import { EditorContext } from '../../../index';

import { BackgroundView } from '../../background';
import { useContainerSelector } from 'components/Editor/hooks/useEditorSession';

import styles from './card.module.scss';
import { Container } from '../../core/container';

const CarouselCardWidgetView = function CarouselCardWidget({ className, style, widgetProps, widgetRef, children }) {
  const dispatch = useDispatch();
  const ref = widgetRef;

  const editorContext = React.useContext(EditorContext);
  const editor = editorContext.editorSession.id;

  const id = _.get(widgetProps, 'uid');
  const type = _.get(widgetProps, 'type');

  const breakpoint = useSelector(state => _.get(state, `${editor}.present.breakpoint`));
  const parentWidget = useContainerSelector(editor, id);
  const isFreeSize = _.get(parentWidget, `properties.desktop.free`, false);
  const editorUIState = _.get(widgetProps, 'editorState');
  const stretched = _.get(widgetProps, 'properties.desktop.stretched', false);
  const container = _.get(widgetProps, `properties.${breakpoint}.container`);

  const background = _.get(widgetProps, 'properties.desktop.background');

  const slides = _.size(children);

  var carouselCardWidgetStyle = {
    ...style,
    ...getStyles(widgetProps, breakpoint)
  }

  return (
    <Container widgetProps={widgetProps} widgetRef={widgetRef}>
      <div
        id={id}
        ref={ref}
        className={cx(className, styles.carouselCard, 'widget')}
        style={carouselCardWidgetStyle}
        data-widget-id={id}
        data-container={true}
        data-widget-type={type}
        data-selectable={false}
        data-free-size={isFreeSize}
      >
        <BackgroundView background={background} />
          <div className={styles.inner}>
            {children}
          </div>

        <VisibleArea id={id} container={container} isFreeSize={isFreeSize}/>
        
      </div>
    </Container>
  );
};

const VisibleArea = ({ id, container, isFreeSize }) => {
  const visibleWidth = _.get(container, `minWidth`);
  const alignment = _.get(container, `alignment`) || 'center';

  var multiplier = 0;
  if (alignment == 'center') {
    multiplier = 0.5;
  } else if (alignment == 'right') {
    multiplier = 1;
  }

  var areaStyles = {
    width: !isFreeSize && `${visibleWidth}px`,
    marginLeft: `calc((100% - ${visibleWidth}px) * ${multiplier})`
  }

  return (
    <>
      <div className={cx(styles.boundary, styles.left)} style={{
        left: `calc((100% - ${visibleWidth}px) * ${multiplier})`,
      }} />
      <div className={cx(styles.boundary, styles.right)} style={{
        right: `calc((100% - ${visibleWidth}px) * ${1 - multiplier})`,
      }} />
      <div id={`${id}_visible_area`} className={cx(styles.visibleArea, 'cs_visible_area__content')} style={areaStyles}>
      </div>
    </>
  );
}

const CarouselCardWidget = React.forwardRef((props, ref) => {
  return <CarouselCardWidgetView {...props} ref={ref} />
});


function getStyles(widget, breakpoint) {
  var styles = {};

  const width = parseFloat(_.get(widget, `properties.${breakpoint}.layout.width`, 100));

  styles = {
    ...styles,
    position: 'relative',
    width: '100%',
  }

  return styles;
}

CarouselCardWidget.actions = (editorSession, breakpoint, props) => {
  return false;
}

CarouselCardWidget.processRequest = (widget) => {
  var background = _.get(widget, 'properties.desktop.background');

  if (!background) {
    return widget;
  }

  var media = _.get(background, 'media');
  if (media) {
    background = {
      ...background,
      media: media.id
    }
  }

  return {
    ...widget,
    properties: {
      ...widget.properties,
      desktop: {
        ...widget.properties.desktop,
        background: background
      }
    }
  }
}

CarouselCardWidget.moveableConfig = (editorSession, widget, breakpoint) => {
  const desktop = breakpoint === 'desktop';

  return {
    draggable: false,
    resizable: false,
    rotatable: false,
    cloneable: true,
    deletable: false,
    renderDirections: [],
    onResize: (widget, layout, breakpoint) => {
      const frame = new Frame(layout);
      frame.set('transform', 'translate', '0px, 0px');
      if(breakpoint == 'desktop') {
        frame.set('height', '100%');
        return frame.get();
      }

      if (breakpoint == 'mobile') {
        const frame = new Frame(layout);
        frame.set('height', '100%');
        frame.set('transform', 'translate', '0px, 0px');

        return frame.get();
      }

      return frame.get();
    },
    onReparent: (widget, parent) => {
      return false
    }
  }
}

export { CarouselCardWidget };